import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { OktaService } from './okta.service';
import { environment } from '../../../environments/environment';
import { SuccessStoryElement, IconElement, ImageElement } from './catalog.service';

export interface TechnologyElement {
    'technologyID': number,
    'name': string,
    'item': number,
    'typeID': number,
    'productLineID': number,
    'statusID': number,
    'slaid': number,
    'published': boolean,
    'revisionDate': string,
    'tagline': string,
    'problem': string,
    'approach': string,
    'features': string,
    'images': ImageElement[],
    'icons': IconElement,
    'caseStudies': string,
    'techDescription': string,
    'docsURL': string,
    'communityURL': string,
    'successStories': SuccessStoryElement[],
    'previousNames': string[],
    'analyticsAccelerator': boolean,
    'shortDescription': string,
    'subtitle': string,
    'solutionArea': number,
    'solutionCapability': string
}

@Injectable()
export class TechnologyService {
    technologyList: BehaviorSubject<TechnologyElement[] | null> = new BehaviorSubject<TechnologyElement[] | null>(null);
    loadFailed = false;

    constructor(private http: HttpClient, private oktaService: OktaService) { };

    get technologyUpdated(): Observable<TechnologyElement[] | null> {
        return this.technologyList.asObservable();
    }

    refresh() {
        this.loadFailed = false;

        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = { headers: headers };

        this.http.get<any>(environment.azure.url + '/admin.technology', options)
            .subscribe({
                next: data => {
                    this.technologyList.next(data);
                    this.loadFailed = false;
                },
                error: msg => {
                    this.loadFailed = true;
                    this.technologyList.next(null);
                    console.log(msg);
                }
            });
    }

    detail(technologyID: number): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = { headers: headers };

        return this.http.get<any>(environment.azure.url + '/admin.technology/' + technologyID, options);
    }

    add(target: TechnologyElement): Observable<any> {
        // Write target to database
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = { headers: headers };
        return this.http.post<any>(environment.azure.url + '/admin.technology.add', {
            name: target.name,
            item: target.item,
            typeID: target.typeID,
            productLineID: target.productLineID,
            statusID: target.statusID,
            slaid: target.slaid,
            published: target.published,
            revisionDate: target.revisionDate,
            tagline: target.tagline,
            problem: target.problem,
            approach: target.approach,
            features: target.features,
            images: JSON.stringify(target.images),
            icons: JSON.stringify(target.icons),
            caseStudies: target.caseStudies,
            techDescription: target.techDescription,
            docsURL: target.docsURL,
            communityURL: target.communityURL,
            successStories: JSON.stringify(target.successStories),
            previousNames: JSON.stringify(target.previousNames),
            analyticsAccelerator: target.analyticsAccelerator,
            shortDescription: target.shortDescription,
            subtitle: target.subtitle,
            solutionArea: target.solutionArea,
            solutionCapability: target.solutionCapability 
        }, options)
    }

    update(target: TechnologyElement): Observable<any> {
        // Update target in database
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = { headers: headers };
        return this.http.post<any>(environment.azure.url + '/admin.technology.update', {
            technologyID: target.technologyID,
            name: target.name,
            item: target.item,
            typeID: target.typeID,
            productLineID: target.productLineID,
            statusID: target.statusID,
            slaid: target.slaid,
            published: target.published,
            revisionDate: target.revisionDate,
            tagline: target.tagline,
            problem: target.problem,
            approach: target.approach,
            features: target.features,
            images: JSON.stringify(target.images),
            icons: JSON.stringify(target.icons),
            caseStudies: target.caseStudies,
            techDescription: target.techDescription,
            docsURL: target.docsURL,
            communityURL: target.communityURL,
            successStories: JSON.stringify(target.successStories),
            previousNames: JSON.stringify(target.previousNames),
            analyticsAccelerator: target.analyticsAccelerator,
            shortDescription: target.shortDescription,
            subtitle: target.subtitle,
            solutionArea: target.solutionArea,
            solutionCapability: target.solutionCapability
        }, options)
    }
}
